import request from '@/utils/ajax'


export function saveConfig(data) {
    return request({
        url: '/wx/manage/dingtalkBot/save',
        method: 'post',
        data: data
    })
}

export function editConfig(data) {
    return request({
        url: '/wx/manage/dingtalkBot/update',
        method: 'put',
        data: data
    })
}

export function deleteConfig(data) {
    return request({
        url: '/wx/manage/dingtalkBot/delete',
        method: 'post',
        data: data
    })
}

export function getList(data) {
    return request({
        url: '/wx/manage/dingtalkBot/list',
        method: 'get',
        params: data
    })
}
